import { Mutation } from '@varo/graphql-schema-types';
import SubmitTransfer from 'services/graphql/mutations/MoveMoney/SubmitTransfer';
import useCancellableMutation, {
  AbortError,
} from 'shared/hooks/useCancellableMutation';
import { getUuid } from 'shared/utils/getUuid/getUuid';

const useTransferConfirm = () => {
  const [{ data, fetching, error }, executeMutation] =
    useCancellableMutation<Mutation>(SubmitTransfer);

  const submitTransfer = async (
    sourceAccountId: string,
    destinationAccountId: string,
    amount: string,
    currency: string,
  ) => {
    try {
      await executeMutation({
        idempotencyId: getUuid(),
        sourceAccountId,
        destinationAccountId,
        amount,
        currency,
      });
    } catch (error) {
      if (error instanceof AbortError) {
        return;
      }

      throw error;
    }
  };
  return {
    data,
    error,
    submitTransfer,
    fetching,
  };
};

export default useTransferConfirm;
